import { EntityType, SlugMappingResponse } from '@chilipiper/api-type-def'
import { nanoid } from 'nanoid'
import { captureException, setTags } from '@sentry/react'
import { fireApiGet } from './api'

export const firerouterService = {
  mapping(
    domain: string,
    entityType: EntityType,
    legacySlug: string
  ): Promise<SlugMappingResponse> {
    return fireApiGet(
      `api/firerouter/v1/slug-mapping-by-legacy-by-subdomain/${domain}/${entityType}/${legacySlug}`,
      {
        headers: {
          'x-request-id': nanoid(),
          'x-caller-ref': `guest/${nanoid()}`,
        },
      }
    )
      .json<SlugMappingResponse | undefined>()
      .then(response => {
        setTags({
          entityType,
          domain,
          legacySlug,
        })
        captureException(new Error('Slug not found from legacySlug'))
        if (!response) {
          return Promise.resolve({
            fireSlug: legacySlug,
            entityType,
            legacySlug,
          })
        }
        return Promise.resolve(response)
      })
      .catch(err => {
        console.error(err)
        setTags({
          entityType,
          domain,
          legacySlug,
        })
        captureException(new Error('Error getting slug mapping by legacySlug'), scope => {
          scope.setContext('Error getting slug mapping by legacySlug', {
            entityType,
            domain,
            legacySlug,
          })
          return scope
        })
        return {
          fireSlug: legacySlug,
          entityType,
          legacySlug,
        } as SlugMappingResponse
      })
  },
  mappingByLegacyId(
    domain: string,
    entityType: EntityType,
    legacyId: string
  ): Promise<SlugMappingResponse> {
    return fireApiGet(
      `api/firerouter/v1/slug-mapping-by-legacy-id-by-subdomain/${domain}/${entityType}/${legacyId}`,
      {
        headers: {
          'x-request-id': nanoid(),
          'x-caller-ref': `guest/${nanoid()}`,
        },
      }
    )
      .json<SlugMappingResponse | undefined>()
      .then(response => {
        if (!response) {
          setTags({
            entityType,
            domain,
            legacyId,
          })
          captureException(new Error('Slug not found from legacyId'))
          return Promise.resolve({
            entityFireId: legacyId,
            fireSlug: legacyId,
            entityType,
            entityLegacyId: legacyId,
            legacySlug: legacyId,
          })
        }
        return Promise.resolve(response)
      })
      .catch(err => {
        console.error(err)
        setTags({
          entityType,
          domain,
          legacyId,
        })
        captureException(new Error('Error getting slug mapping by legacyId'), scope => {
          scope.setContext('Error getting slug mapping by legacyId', {
            entityType,
            domain,
            legacyId,
          })
          return scope
        })
        return {
          entityFireId: legacyId,
          fireSlug: legacyId,
          entityType,
          entityLegacyId: legacyId,
          legacySlug: legacyId,
        } as SlugMappingResponse
      })
  },
}
